import { Injectable } from '@angular/core';

@Injectable()
export class PointCashFacade {
  cashPercentage: number = 0;
}
